<template>
    <div class="container">
        <!-- <headerContainer @languageChange="change"></headerContainer> -->
        <div class="content-container">
            <router-view :language='language'></router-view>
        </div>
        <footerContainer></footerContainer>
        <picUpload v-if="isPicUpload"></picUpload>
        <faceUpload v-if="isFaceUpload"></faceUpload>
        <voiceRec v-if="isVoiceUplaod"></voiceRec>
    </div>
</template>
<script>

import header from './header'
import footer from './footer'
import picUpload from './picUpload'
import faceUpload from './faceUpload'
import voiceRec from './voiceRec'
import bus from '../bus'

export default {
    components: {
        "headerContainer": header,
        "footerContainer": footer,
        "picUpload": picUpload,
        "faceUpload": faceUpload,
        "voiceRec": voiceRec
    },
    data() {
        return {
            language: 0,
            isPicUpload: false,
            isFaceUpload: false,
            isVoiceUplaod:false
        }
    },
    methods: {
        change(e) {
            this.language = e.language
            console.log(this.language)
        }
    },
    beforeDestroy() {
        bus.$off('voiceSearch');
        bus.$off('picSearch');
        bus.$off('faceSearch');
        bus.$off('closeVoiceUpload');
        bus.$off('closePicUpload');
        bus.$off('closeFaceUpload');
    },
    mounted() {
        $('#app').css({
        "height": 'auto'
        })
    },
    created() {
        var that = this;
        bus.$on('voiceSearch',function(){
            that.isVoiceUplaod = true;
        })
        bus.$on('picSearch',function(){
            that.isPicUpload = true;
        })
        bus.$on('faceSearch',function(){
            that.isFaceUpload = true;
        })
        bus.$on('closeVoiceUpload',function(){
            that.isVoiceUplaod = false;
        })
        bus.$on('closePicUpload',function(){
            that.isPicUpload = false;
        })
        bus.$on('closeFaceUpload',function(){
            that.isFaceUpload = false;
        })
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
}
</script>
<style>
    .container {
        display: flex;
        align-items: center;
        justify-content: center;
        /* position: relative; */
        /* width: 20.08rem; */
        margin: 0px auto;
    }

    .content-container {
        width: 20.08rem;
        /* background: #FFF; */
        margin: 0px auto;
        padding-bottom: 1rem !important;
        box-sizing: border-box;
    }

    .el-message {
        min-width: 5rem;
        padding: 0.15rem 0.15rem 0.15rem 0.2rem;
        box-sizing: border-box;
    }

    .el-message__icon {
        font-size: 0.36rem;
    }

    .vjs-remaining-time.vjs-time-control.vjs-control {
        display: none!important;
    }

    .vjs-time-control.vjs-time-divider {
        display: none!important;
    }
</style>
